<template>
  <div class="page">
    <div class="page-header">
      <div class="header-layer">
        <div class="header-title">
          <h3>Нас</h3>
          <span class="divider"></span>
          <p>Насны ангилалаар үзэх</p>
        </div>

        <div class="header-breadcrumb">
          <router-link to="/">
            <span>Эхлэл</span>
            <i class="isax isax-arrow-right-4"></i>
          </router-link>

          <router-link to="" class="current">
            <span>Нас</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="w-90 h-full md:pb-44 seeroo-media seeroo-media-age flex flex-col lg:flex-row">
      <div class="relative character-page">
        <div class="seeroo-cat">
          <div class="seeroo-cat-box">
            <div class="seeroo-cat-box-header">
              <i class="isax isax-sort"></i>
              <h2>Насны ангилал</h2>
            </div>
            <div class="cat-list cat-list-seeroo">
              <router-link to="/age/all" :class="`btn btn-sm m-1 highlight ${$route.params.cat == 'all' ? 'active' : ''}`">
                Бүх насны ангилал
              </router-link>
              <router-link :to="`/age/${item.id}`" v-for="item in types" :key="item.id"
                           :class="`btn btn-sm m-1 highlight ${$route.params.cat == item.id ? 'active' : ''}`">
                {{ item.title }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="seeroo-cat-box">
        <div class="seeroo-cat-box-header border-b-[0px] visible lg:hidden flex justify-between">
          <div class="flex justify-between">
            <i class="isax isax-emoji-happy"></i>
            <h2>Насны ангилал</h2>
          </div>
          <Button label="Сонгох" class="visible lg:hidden" @click="showActorsModal"/>
        </div>
        <div class="cat-list cat-list-seeroo">
        </div>
      </div>

      <div style="padding-left: 20px; width: 100%;">
        <router-view :key="$route.fullPath"/>
      </div>
    </div>
  </div>
  <Dialog :showHeader="false" class="auth-modal" v-model:visible="isAgeTypes" :modal="true" :dismissableMask="true"
          position="center" :closable="true" :style="{width: '240px'}">
    <div class="relative">
      <div class="seeroo-cat">
        <div>
          <div class="seeroo-cat-box-header flex justify-between">
            <div class="flex">
              <i class="isax isax-emoji-happy"></i>
              <h2>Насны ангилал</h2>
            </div>
            <i class="isax isax-close-circle" @click="showActorsModalHide"></i>
          </div>
          <div class="cat-list cat-list-seeroo">
            <router-link to="/age/all" :class="`btn btn-sm m-1 highlight ${$route.params.cat == 'all' ? 'active' : ''}`">
              Бүх насны ангилал
            </router-link>
            <router-link :to="`/age/${item.id}`" v-for="item in types" :key="item.id"
                         :class="`btn btn-sm m-1 highlight ${$route.params.cat == item.id ? 'active' : ''}`">
              {{ item.title }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import {imageUrl} from "../../utils";
import api from "../../store/_boot/baseApi"

export default {
  components: {},
  setup() {

  },
  data() {
    return {
      types: [],
      characters: [],
      isAgeTypes: false,
    }
  },

  computed: {},

  created() {
    this.getAges();
  },

  watch: {},

  methods: {
    imageUrl,

    getAges() {
      api.get('/api/m/age').then(({data}) => {
        this.types = data;
      })
    },
    showActorsModal() {
      this.isAgeTypes = true;
    },
    showActorsModalHide() {
      this.isAgeTypes = false;
    },
  }
};
</script>
<style>
</style>